import {
  createResourceReducer,
  updateResourceState,
  RESOURCE
} from '@unicus/react-ui-kit';

import {
  STATISTICS_GET,
  STATISTICS_GET_ATTENDANCES_IN_PROGRESS_FINISHED,
  STATISTICS_GET_FINISHED,
  STATISTICS_GET_PRODUCTIVITY_FINISHED,
  STATISTICS_GET_STEPS,
  STATISTICS_GET_STEPS_FINISHED,
  STATISTICS_USER_GET_FINISHED
} from './dashboardActions';

const dashboardReducer = createResourceReducer('statistics', [], {
  [STATISTICS_GET](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true
    }));
  },

  [STATISTICS_GET_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      data: { ...action.payload.data },
      loading: false
    }));
  },

  [STATISTICS_USER_GET_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      userProductivity: { ...action.payload.data }
    }));
  },

  [STATISTICS_GET_PRODUCTIVITY_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      productivity: action.payload.data
    }));
  },

  [STATISTICS_GET_STEPS](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true,
      onlyConcluded: action.payload?.onlyConcluded
    }));
  },

  [STATISTICS_GET_STEPS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      steps: action.payload.data,
      loading: false
    }));
  },

  [STATISTICS_GET_ATTENDANCES_IN_PROGRESS_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      attendances: action.payload.data
    }));
  }
});

export default dashboardReducer;
